import { useCallback } from 'react';
import { useRouter } from 'next/router';

export const RETURN_HREF_QUERY_PARAM = '_UCR_return_href';

export const useContextualRouting = () => {
  const router = useRouter();

  const returnHrefQueryParam =
    typeof router.query[RETURN_HREF_QUERY_PARAM] === 'string'
      ? router.query[RETURN_HREF_QUERY_PARAM]
      : undefined;

  const watchedQuery = { ...router.query };
  delete watchedQuery[RETURN_HREF_QUERY_PARAM];

  const returnHref = returnHrefQueryParam ?? router.asPath;

  const queryHash = JSON.stringify(watchedQuery); // used as memoization dependency

  const makeContextualHref = useCallback(
    extraParams => {
      const params = new URLSearchParams({
        ...router.query,
        ...extraParams,
        [RETURN_HREF_QUERY_PARAM]: returnHref,
      });

      return `${router.pathname}?${params.toString()}`;
    },
    [queryHash, returnHref]
  );

  return { returnHref, makeContextualHref };
};
